/**
 * Fase 6/7 — Regra pura de acesso à área interna.
 * Espelha o backend `require_entitlement` / `phase3.user_has_premium_read`:
 * - Admin sempre autorizado (bypass administrativo).
 * - `access.premium_active === true` OU `access.premium_pending_review === true` liberam.
 * - Sem entitlement válido (revoked/expired/none) bloqueia.
 * Isolado em módulo próprio para permitir teste unitário puro.
 */
export function isAdminUser(user) {
  return user?.role === "administrador" || user?.access?.is_admin === true;
}

export function isPremiumAllowed(user) {
  return (
    user?.access?.premium_active === true ||
    user?.access?.premium_pending_review === true
  );
}
